import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { CreateEventForm } from '../../types';

@Component({
  selector: 'app-event-management-location',
  templateUrl: './event-management-location.component.html',
  styleUrls: ['./event-management-location.component.scss'],
})
export class EventManagementLocationComponent {
  @Input() innerForm: FormGroup<CreateEventForm>;
  @Input() id: string;
}
